import { render, staticRenderFns } from "./m-folders-treeview.vue?vue&type=template&id=441b7d50&scoped=true&lang=pug"
import script from "./m-folders-treeview.vue?vue&type=script&lang=js"
export * from "./m-folders-treeview.vue?vue&type=script&lang=js"
import style0 from "./m-folders-treeview.vue?vue&type=style&index=0&id=441b7d50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441b7d50",
  null
  
)

export default component.exports